import { Button } from "@/components/ui/Button";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/Dialog";
import { getMyOrder } from "@/api/order";
import type { OrderData } from "@/api/order/Types";
import { WayBillCard } from "../card/WayBillCard";
import { ClipboardList } from "lucide-react";

export function Myorder() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [orders, setOrders] = useState<OrderData[]>([]);

  const openDialog = async () => {
    setDialogOpen(true);
    try {
      const response = await getMyOrder();
      setOrders(response.data);
    } catch (error) {
      console.error('获取订单失败:', error);
    }
  };

  return (
    <>
      <Button
        variant="ghost"
        className="gap-3 w-full justify-start hover:bg-accent hover:text-blue-600 group px-2 text-[#0F0F0F]"
        onClick={openDialog}
      >
        <div className="h-5.5 w-5.5 flex items-center justify-center">
          <ClipboardList className="group-hover:text-blue-600" />
        </div>
        <span className="text-[#0F0F0F] text-base">我的订单</span>
      </Button>

      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>我的订单</DialogTitle>
            <DialogDescription className="sr-only">
              查看您的所有订单信息
            </DialogDescription>
          </DialogHeader>
          <div className="py-4 space-y-4">
            {orders.length > 0 ? (
              orders.map((order) => (
                <WayBillCard
                  key={order.id}
                  waybillNumber={order.order_no}
                  infos={order.infos}
                />
              ))
            ) : (
              <div className="text-center text-gray-500 py-8">暂无订单数据</div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
